import React from "react";
import { Form } from "react-final-form";
import { useAuth } from "@syos-music/auth";
import { DateField } from "@syos-music/form";
import qs from "qs";
import startOfISOWeek from "date-fns/startOfISOWeek";
import subWeeks from "date-fns/subWeeks";

import { Container, Grid, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";

import Layout from "components/common/Layout";

export default function AffiliationsPage() {
  const auth = useAuth();

  const initialValues = React.useMemo(() => {
    const adjustUTC = (date) =>
      new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));

    const endDate = adjustUTC(startOfISOWeek(new Date()));
    const startDate = subWeeks(endDate, 1);

    return { startDate, endDate };
  }, []);

  return (
    <>
      <Layout.Toolbar fixed>
        <Typography variant="h4" color="primary">
          Générer un export des affiliations
        </Typography>
      </Layout.Toolbar>

      <Container fixed sx={{ pt: [2, 3] }}>
        <Form
          initialValues={initialValues}
          onSubmit={async (values) => {
            const accessToken = await auth.getAccessToken();

            const [startDate] = values.startDate.toISOString().split("T");
            const [endDate] = values.endDate.toISOString().split("T");

            const query = qs.stringify({ startDate, endDate });

            // prettier-ignore
            const fetchUrl = `${process.env.REACT_APP_API_BASE_URL}/affiliations.csv?${query}`
            const headers = { authorization: `Bearer ${accessToken}` };

            const blob = await fetch(fetchUrl, { headers }).then((res) =>
              res.blob()
            );

            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `export-affiliations__${startDate}__${endDate}.csv`;
            a.click();

            window.URL.revokeObjectURL(url);
          }}
          keepDirtyOnReinitialize
        >
          {({ handleSubmit, submitting }) => (
            <form onSubmit={handleSubmit} noValidate autoComplete="off">
              <Grid container>
                <Grid item xs={12} sm={6}>
                  <DateField name="startDate" required label="Début" />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <DateField name="endDate" required label="Fin" />
                </Grid>

                <Grid item xs={12} align="right">
                  <LoadingButton type="submit" loading={submitting}>
                    Générer
                  </LoadingButton>
                </Grid>
              </Grid>
            </form>
          )}
        </Form>
      </Container>
    </>
  );
}
